module.exports = __webpack_public_path__ + "img/logo.2c4e00a5.png";